module.exports = __webpack_public_path__ + "static/media/logo.577c47c0.svg";